import { breakpoint } from '@/helpers/BreakpointHelper';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import React, { FC, useMemo, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import SwiperCore from 'swiper';
import 'swiper/swiper.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';

const PanelContainer = styled.div`
  .swiper-container {
    width: 100%;
    overflow: visible;
  }
  .swiper-slide {
    height: 80px;
  }
  ${breakpoint(640)} {
    .swiper-slide {
      height: 56px;
    }
  }
`;
const TabButton = styled.div<{ active: boolean }>`
  cursor: pointer;
  flex: 1;
  text-align: center;
  display: block;
  font-weight: 700;
  line-height: 80px;
  font-size: 20px;
  height: 80px;
  border-bottom: 3px solid #e5e6e8;
  border-color: ${(props) => (props.active ? `#1cabe2` : `#e5e6e8`)};
  color: ${(props) => (props.active ? `#1cabe2` : `#e5e6e8`)};
  transition: border 0.25s, color 0.25s;
  ${breakpoint(640)} {
    height: 56px;
    line-height: 56px;
    font-size: 16px;
  }
  &:hover {
    border-color: #1cabe2;
    color: #1cabe2;
  }
`;

interface SupportHistoryTabProps {
  tabs: { title: string; link: string }[];
  activeTab: number;
  setActiveTab: (index: number) => void;
  navigate: (path: string) => void;
  slidesPerView: number | number[];
  swiperInstance: SwiperCore | null;
  setSwiperInstance: (swiper: SwiperCore) => void;
  location: Location;
}

const SupportHistoryTab: FC<SupportHistoryTabProps> = ({
  tabs,
  activeTab,
  setActiveTab,
  slidesPerView,
  swiperInstance,
  setSwiperInstance,
}) => {
  // 탭 클릭
  const handleTabMenu = (index: number, link: string) => {
    if (swiperInstance && window.innerWidth <= 400) {
      swiperInstance.slideTo(index);
    }

    const separator = link.includes('?') ? '&' : '?';
    navigate(`${link}${separator}tabIndex=${index}`);
    setActiveTab(index);
  };

  // activeTab 변경 시 자동 이동 (다른 페이지 전환 후에도 유지)
  useEffect(() => {
    if (swiperInstance && window.innerWidth <= 400) {
      swiperInstance.slideTo(activeTab);
    }
  }, [activeTab, swiperInstance]);

  return (
    <PanelContainer>
      <Swiper
        onSwiper={(swiper) => setSwiperInstance(swiper)}
        slidesPerView={slidesPerView}
        navigation={false}
        allowTouchMove={window.innerWidth <= 400}
        onResize={(swiper) => swiper.update()}
      >
        <div className="swiper-container">
          {tabs.map((t, index) => (
            <SwiperSlide key={`${t.link}-${index}`}>
              <TabButton
                active={activeTab === index}
                onClick={() => handleTabMenu(index, t.link)}
              >
                {t.title}
              </TabButton>
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
    </PanelContainer>
  );
};

export default SupportHistoryTab;
